import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const reqUploadAvFileToFtp = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/jt1078data/requploadavfiletoftp/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}
